import React, { ReactNode } from 'react';

const PageHeaderText = ({
  title,
  description,
  children,
  tagText,
  className = ''
}: {
  title: string;
  description?: string;
  children?: ReactNode;
  tagText?: string;
  className?: string;
}) => {
  return (
    <div className={`flex items-center justify-between gap-4 flex-wrap mb-8 w-full ${className}`}>
      <div className='grow space-y-2'>
        <div className='flex gap-2 items-center'>
          <h1 className='font-semibold text-xl md:text-2xl'>{title}</h1>
          {tagText && (
            <p className='text-xs text-gray-5 py-1 px-[6px] bg-gray-11 rounded'>{tagText} </p>
          )}
        </div>

        {description && <p className='text-sm text-gray-5 max-w-[640px] w-full'>{description}</p>}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};

export default PageHeaderText;
